import { render } from "./HomeView.vue?vue&type=template&id=e4a05ad2&scoped=true"
import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=e4a05ad2&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a05ad2"],['__file',"core/views/HomeView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e4a05ad2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e4a05ad2', __exports__)) {
    api.reload('e4a05ad2', __exports__)
  }
  
  module.hot.accept("./HomeView.vue?vue&type=template&id=e4a05ad2&scoped=true", () => {
    api.rerender('e4a05ad2', render)
  })

}


export default __exports__